<section class="section-div">
  <div class="content-details mb-3">
    <form action="" [formGroup]="Financing">
      <div>
        <table class="table">
          <thead
            style="
              padding: 18px;
              background-color: #0c0249;
              color: white;
              text-align: center;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            "
          >
            <tr>
              <th scope="col">S.No</th>
              <th scope="col">Means of Financing</th>
              <th scope="col">Amount (Rs. in Lakhs)</th>
            </tr>
          </thead>
          <tbody
            style="
              background-color: #fff;
              text-align: center;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            "
          >
            <tr>
              <th scope="row" class="pt-4">1</th>
              <td class="pt-4 text-left">Contribution of StartupTN</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="financingStartuptnContribution"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">2</th>
              <td class="pt-4 text-left">Contribution of Host Institution</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="financingHostIncContribution"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">3</th>
              <td class="pt-4 text-left">
                Contribution of Industry/Corporate Partner
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="financingIndustryContribution"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">4</th>
              <td class="pt-4 text-left">
                Revenue generation from CoE Activities
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="financingRevenueGeneration"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">5</th>
              <td class="pt-4 text-left">
                Fundraising through CSR or sponsorship
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="financingSponsorship"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-right">Total</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="financingTotal"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center mt-3 mb-3">
        <button
          mat-raised-button
          color="primary"
          (click)="saveBtn()"
          *ngIf="!showForm"
        >
          Save & Continue
        </button>
      </div>
    </form>
  </div>
</section>
